import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Route, Router } from "@angular/router";
@Component({
  selector: "app-dealers",
  templateUrl: "./dealers.component.html",
  styleUrls: ["./dealers.component.css"],
})
export class DealersComponent implements OnInit {
  selectedTab: string = "All";
  selectedPortfolio: string;
  dealersdata: any;
  tempData: any;
  searchText: string;
  tab1: any;
  tab2: string;
  loader: boolean = false;
  selectedTabData: any;
  noData: any;
  constructor(private activateroute: ActivatedRoute, private route: Router) {}

  ngOnInit(): void {
    this.activateroute.queryParams.subscribe((params) => {
      this.selectedPortfolio = params.data;
    });
    this.tempData = JSON.parse(localStorage.getItem("dealerData"));
    let tabs = Object.values(this.tempData.CATEGORY);
    this.tab1 = tabs[0].toString().split(",");
    this.dealersdata = this.tempData.DEALERS;
    this.selectedTabData = this.tempData.DEALERS;
  }
  onSearchKeyUp() {
    let searchData = this.selectedTabData.filter((e: any) => {
      let name = e.DEALER_NAME.toLowerCase();
      return name.includes(this.searchText?.toLowerCase())
        ? name.includes(this.searchText.toLowerCase())
        : undefined;
    });
    searchData
      ? (this.dealersdata = searchData)
      : (this.dealersdata = this.selectedTabData);
  }

  redirecToUrl(data, item) {
    localStorage.setItem("selectedDealer", JSON.stringify(item));
    if (data == "details") {
      this.route.navigate(["/dealer-details"]);
    }
  }
  changeTab(tabId: any) {
    this.loader = true;
    this.selectedTab = tabId;
    this.searchText = "";

    this.selectedTabData = this.tempData.DEALERS.filter((e: any) => {
      if (tabId == "Home Appliances") {
        return e.CD == "Y";
      } else if (tabId == "Mobile Store") {
        return e.MOB == "Y";
      }
      if (tabId == "Main Dealers") {
        return e.DEALER_TYPE == "DEALER";
      } else if (tabId == "Dealers") {
        return e.DEALER_TYPE == "ASC";
      }
      return e;
    });
    this.selectedTabData
      ? (this.dealersdata = this.selectedTabData)
      : (this.dealersdata = this.tempData.DEALERS);
    setTimeout(() => {
      this.loader = false;
    }, 1000);
  }
  getDirection(item: any) {
    // @ts-ignore
    Dialog.showMsg(item.LAT, item.LANG);
  }
  goBack(){
    this.route.navigate(["/dealer-locator"]);
  }
}
